import { endOfDay, startOfDay, subWeeks } from 'date-fns';

import { MeetingView } from './model/meeting-view.model';

export interface TranscriptImportDialogState {
    pending: {
        reload?: boolean;
        meetings?: boolean;
    };
    dateRange: { from: Date; to: Date };
    maxDate: Date;
    userId?: number;
    selectedUserId?: number;
    selectedUserName?: string;
    currentRequestSelectedUserId?: number;
    currentRequestToken?: string;
    msftUserNotFound?: boolean;
    meetings?: MeetingView[];
}

export const defaultState = (): TranscriptImportDialogState => ({
    pending: {},
    dateRange: {
        from: subWeeks(startOfDay(new Date()), 1),
        to: endOfDay(new Date()),
    },
    maxDate: endOfDay(new Date()),
});
